export default "<ng-content select=\"tc-dropdown-button\"></ng-content>\n<ng-content select=\"tc-dropdown-content\"></ng-content>\n"